import classnames from 'classnames';
import React from 'react';

import styles from '@/components/global/pills/pill-icon.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  primary?: boolean;
  secondary?: boolean;
  dark?: boolean;
  classNames?: string;
  label?: string;
  tabIndex?: number | undefined;
}

const PillIcon = (props: Props): React.JSX.Element | null => {
  const { primary, secondary, dark, classNames, label, tabIndex } = props;
  const className = classnames({
    [styles.primary]: primary,
    [styles.secondary]: secondary,
    [styles.dark]: dark
  });
  return (
    <div className={`${className} ${classNames || ''}`}>
      <span className={styles.label} tabIndex={tabIndex !== null ? tabIndex : undefined}>
        {label}
      </span>
      {props.children}
    </div>
  );
};

export default PillIcon;
